import * as angular from 'angular';

import { ComponentDefinition } from '../../models';

class AlarmStatusController implements angular.IComponentController {
    static $inject = [];

}

export const wtAlarmStatus: ComponentDefinition = {
    componentId: 'wtAlarmStatus',
    controller: AlarmStatusController,
    template: require('./alarmStatus.component.html'),
    controllerAs: 'vm',
    bindings: {
        alarm: '=',
        linkParams: '=?'
    }
};
